<template>
  <div v-if="!app_loading" class="trial-banner d-flex align-items-center">
    <video-modal-activator
      v-if="!hasActivatorButton"
      :size="activatorSize"
      @open-modal="openModal"
    />
    <slot v-else name="activator" @click="openModal" />
    <div v-if="showModal" class="video-modal">
      <div class="overlay" @click="closeModal"></div>
      <div class="modal-content">
        <div class="modal-header">
          <h3 v-if="title" class="d-none d-md-flex">{{ title }}</h3>
          <button class="close-button ml-auto" @click="closeModal">✖</button>
        </div>
        <div class="modal-body animated position-relative">
          <div
            v-if="isLoading"
            class="position-absolute w-100 h-100 d-flex justify-content-center align-items-center"
          >
            <i class="fa fa-spinner fa-spin fa-3x"></i>
          </div>
          <iframe
            :class="{ show: !isLoading }"
            :src="videoUrl"
            allowfullscreen
            class="fade animated"
            frameborder="0"
            @load="onIframeLoad"
          ></iframe>
        </div>
        <div v-if="notes" class="modal-notes">
          <p v-html="notes" />

          <div v-if="learnMoreLink" class="modal-link">
            <a :href="learnMoreLink" rel="noopener noreferrer" target="_blank">
              Learn more
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import VueCookies from 'vue-cookies'
import VideoModalActivator from './video-modal-activator.vue'
import auth from '../auth'

export default {
  name: 'VideoModal',

  components: {
    VideoModalActivator
  },

  props: {
    title: {
      type: String,
      default: null
    },
    notes: {
      type: String,
      default: null
    },
    cookieName: {
      type: String,
      required: true
    },
    videoUrl: {
      type: String,
      required: true
    },
    learnMoreLink: {
      type: String,
      default: null
    },
    hasActivatorButton: {
      type: Boolean,
      default: false
    },
    activatorSize: {
      type: String,
      default: 'medium'
    },
    shouldShowInFirstVisit: {
      type: Boolean,
      default: true
    },
    useCustomActivatorAttr: {
      type: Boolean,
      default: false
    },
    customActivatorAttr: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      showModal: false,
      profile: auth.user.profile,
      isLoading: false
    }
  },

  computed: {
    ...mapState(['app_loading', 'shouldShowVideoModal', 'isIntroVideoVisible']),

    parsedCookieName() {
      return `${this.cookieName}-${this.profile?.id}`
    }
  },

  watch: {
    shouldShowVideoModal() {
      if (this.useCustomActivatorAttr) {
        return
      }

      this.showModal = this.shouldShowVideoModal
    },

    customActivatorAttr() {
      if (!this.useCustomActivatorAttr) {
        return
      }

      this.showModal = this.customActivatorAttr
    }
  },

  created() {

  },

  methods: {
    ...mapActions(['setShouldShowVideoModal', 'setIsIntroVideoVisible']),

    closeModal() {
      this.showModal = false
      this.setShouldShowVideoModal(false)
      this.setIsIntroVideoVisible(null)
      this.$cookies.set(this.parsedCookieName, 'viewed', '3650d') // Set cookie to expire in 10 years
      this.$emit('close-modal')
    },

    openModal() {
      this.isLoading = true
      this.showModal = true
      this.setShouldShowVideoModal(true)
    },

    onIframeLoad() {
      this.isLoading = false
    }
  },
  mounted() {
    this.isLoading = true

    if (this.isIntroVideoVisible) {
      return
    }

    this.$cookies = VueCookies

    if (
      !this.$cookies.get(this.parsedCookieName) &&
      this.shouldShowInFirstVisit
    ) {
      this.showModal = true
      return this.setIsIntroVideoVisible(true)
    }

    return this.setIsIntroVideoVisible(null)
  }
}
</script>
